const TezosCnt = {
  symbol: "XTZ",
  name: "tezos",
  meta: {
    title: "Buy tezos | Sell tezos | tezos prices and charts",
    description:
      "Tezos is a blockchain network based on smart contracts, not unlike Atrium. Buy and sell Tezos ciphers at coinnik Market at the best price, lowest commission and fastest time.",
    keywords: "Buy tezos, sell tezos, what is tezos, tezos",
  },
  scripts: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: " چگونه تزوس بخریم؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "در پلتفرم معاملاتی کوین‌نیک مارکت می‌توانید با کارت بانکی عضو شتاب و کمترین کارمزد، اقدام به خرید بایننس کوین کنید. قیمت تزوس در کوین‌نیک مارکت توسط خود شما تعیین می‌شود.",
        },
      },
      {
        "@type": "Question",
        name: "بهترین کیف پول تزوس کدام است؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "برای ذخیره تزوس می‌توانید از انواع کیف‌پول‌های معتبر استفاده کنید. از بین کیف‌پول‌های سخت افزاری لجر بهترین گزینه است. از بین کیف‌پول‌های نرم افزاری نیز می‌توانید از تراست ولت، اگزدوس، اتمیک و ... برای نگهداری رمز ارز XTZ استفاده کنید.",
        },
      },
      {
        "@type": "Question",
        name: " آیا در کوین نیک مارکت می‌توان تزوس را نگهداری کرد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " در کوین‌نیک مارکت یک کیف پول اختصاصی و امن تزوس دارید، که می‌توانید رمز ارز تزوس خود را در آن نگهداری کنید. در این صورت دیگر هیچ نگرانی و استرسی بابت مسدود شدن موجودی‌تان در صرافی‌های خارجی به علت تحریم‌های مالی علیه ایران نخواهید داشت.",
        },
      },
      {
        "@type": "Question",
        name: "آیا تزوس ارزش سرمایه‌گذاری دارد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " بله، این کوین سرمایه گذاری خوبی محسوب می‌شود. احتمالاً ارزش کوین تزوس افزایش می‌یابد، زیرا اکثر تحلیلگران روند صعودی را برای XTZ پیش بینی می‌کنند.",
        },
      },
    ],
  },
  faq: [
    {
      question: "How to buy Tezos",
      answer: "Buy_Tezos",
      id: "toggler1",
    },
    {
      question: "What is the best Tezos wallet?",
      answer: "Tezos_wallet_description",
      id: "toggler2",
    },
    {
      question: "Can I keep a Tezos at coinnik Market?",
      answer: "Keep_Tezos_description",
      id: "toggler3",
    },
    {
      question: "Is Tezos worth the investment?",
      answer: "Tezos_investment",
      id: "toggler4",
    },
  ],
  body: [
    [
      {
        heroTitle: "Tezos market statistics and information",
        subTitle: "What is Tezos?",
        content: "Tezos_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "History of Tezos",
        content: "Tezos_history_description",
        btnTitle: "Buy and sell Tezos",
        btnLink: "",
        linkTitle: "Read more on the blog",
        Link: "",
      },
    ],
    [
      {
        heroTitle:
          "Buy and sell Tezos without intermediaries in coinnik Market",
        subTitle: "Buy Tezos",
        content: "Buy_Tezos_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "Sell Tezos",
        content: "Sell_Tezos_description",
        btnTitle: "Buy and sell Tezos",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
    ],
  ],
  posts: [
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
  ],
  blogTitle: "The latest Tezos analysis on the blog",
  informationTitle: "Tezos market statistics and information",
};

export default TezosCnt;
